import {ReactElement, useState} from 'react';
import Toolbar from "@mui/material/Toolbar";
import {DataGridPremium } from '@mui/x-data-grid-premium';
import { GridColDef } from '@mui/x-data-grid';
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Title from "../../components/Title";
import {formatSwedishDateTime} from "../../components/TimeFormat";
import {useGetBroker, useSyncBroker} from "../../application/BrokerService";
import SnackbarComponent, {defaultSnackbarState, SnackbarState} from "../../components/SnackbarComponent";
import {RefreshDataFunction} from "../../components/types/RefreshDataFunction";
import {Statistics} from "../../domain/staticdata/Statistics";
import {useAutoSizeGrid} from "../../components/AutoSizeGridHook";
import {Broker} from "../../domain/staticdata/Broker";
import RefreshStaticComponent from "../../components/RefreshStaticComponent";



export default function Brokers(): ReactElement {

    const { data, loading , apiFunction } = useGetBroker();
    const [ snackbarState, setSnackbarState ] = useState<SnackbarState>(defaultSnackbarState);
    const syncBroker: RefreshDataFunction<Statistics> = useSyncBroker();
    const apiRef = useAutoSizeGrid<Broker>({
        data: data,
        loading: loading,
        columns: [
            'shortName',
            'swiftAddress',
            'fullName',
            'country',
            'parik',
            'changedTimestamp'
        ]
    });

    const initialState =
        {
            columns: {
                columnVisibilityModel: {
                },
                dimensions: {
                    shortName: { width: 200 },
                    fullName: { flex: 1 },
                    country: { width: 100 },
                    parik: { width: 150 },
                    changedTimestamp: { width: 300},
                    swiftAddress: { width: 150}
                }
            }
        }

    const columns: GridColDef[] = [
        { field: 'shortName', headerName: 'Short Name' },
        { field: 'swiftAddress', headerName: 'Swift' },
        { field: 'fullName', headerName: 'Full Name' },
        { field: 'country', headerName: 'Country' },
        { field: 'parik', headerName: 'parik' },
        { field: 'changedTimestamp', headerName: 'Changed Timestamp', renderCell: (params) =>
                formatSwedishDateTime(params.row.changedTimestamp)
        }
    ];
    return (
        <Container maxWidth={ false } sx={{ mt: 4, mb: 4 }}>
            { <Toolbar/> }
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                <Grid size={{ xs: 12, md: 10, lg: 10 }}>
                    <Title>Brokers</Title>
                </Grid>
                <RefreshStaticComponent refreshFunction={ syncBroker } dataFunction={ apiFunction } setSnackbarState={ setSnackbarState }/>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ height: 1000 }}>
                    <DataGridPremium
                        apiRef={apiRef}
                        initialState={initialState}
                        showToolbar
                        loading={loading}
                        rows={data}
                        columns={columns}
                        density={"compact"}
                        getRowId={(row) => row.shortName}
                    />
                </Grid>
            </Grid>
            <SnackbarComponent setState={ setSnackbarState} state={ snackbarState}/>
        </Container>
    );
}